import { useCallback, useMemo } from 'react';
import Searcher from './Searcher';
import { generateColumnsDefaultConfiguration } from '../../../../../../components/dataGrid/columnHelpers';
import { adaptFinanciadoresArray, GET_CLIENTES_PAGINATED_RECLAMOS } from '../../../../../../data/graphQL/queries/Reclamos/getAllClientes';

const FinanciadorField = ({
    onChange,
    idCliente,
    disabled,
    codDelegacion
}) => {

    const CONFIGURATED_COLUMNS = useMemo(() => (generateColumnsDefaultConfiguration(columns)), [columns]);

    const getSearchParams = useCallback((textValue) => {
        const filterDelegacion = codDelegacion ? {
            cod_Delegacion: { eq: codDelegacion }
        } : {};

        const searchParams = {
            and: [filterDelegacion]
        };

        if (textValue) {
            searchParams.and.push({
                or: [
                    { nom_com: { contains: textValue } },
                    { cod_Cliente: { contains: textValue } },
                    { cUIT: { contains: textValue } },
                ]
            });
        }

        return searchParams;
    }, [codDelegacion]);

    const handleRowClick = (row) => {
        onChange('idCliente', row?.cod_Cliente);
    }

    const getEntityValue = (row) => {
        const value = !!row ? `${row.cod_Cliente} - ${row.nom_com}` : null;
        return value;
    }

    return <Searcher
        displayName='Financiador'
        titleModal='Seleccionar Financiador SAP'
        entityName='allClientesPaging'
        entityId='cod_Cliente'
        entityIdValue={idCliente}
        columns={CONFIGURATED_COLUMNS}
        query={GET_CLIENTES_PAGINATED_RECLAMOS}
        adapter={adaptFinanciadoresArray}
        getSearchParams={getSearchParams}
        onRowClick={handleRowClick}
        getEntityValue={getEntityValue}
        disabled={disabled}
    />
}

export default FinanciadorField;


const columns = [
    {
        field: 'cod_Cliente',
        headerName: 'Cod. Cliente',
        flex: 1
    },
    {
        field: 'cUIT',
        headerName: 'CUIT',
        flex: 1
    },
    {
        field: 'nom_com',
        headerName: 'Nombre',
        flex: 1,
    }
];